import React, { Component } from "react";
import {
  Button,
  Segment,
  Form,
  Select,
  Grid,
  Table,
  Message,
} from "semantic-ui-react";

import find from "lodash/find";

import constants from "../../constants";

const _ = { find };
const optionsGradeLevel = constants.breakdownGradeLevel;
const optionsPaymentSchedule = constants.paymentSchedule;
const breakdownOfFees = constants.breakdownOfFees;
const tuitionFeeSched = constants.tuitionFeeSched;

export class EnrollmentDetails extends Component {
  state = {
    haveErrors: false,
    message: "",
    error: {
      gradeLevel: false,
      paymentSchedule: false,
    },
    breakdown: null,
  };

  continue = (e) => {
    e.preventDefault();
    if (this.handleValidation()) {
      this.setState({ haveErrors: false });
      this.props.nextStep();
    } else {
      this.setState({
        haveErrors: true,
        message: "Required fields must not be blank.",
      });
    }
  };

  back = (e) => {
    e.preventDefault();
    this.props.prevStep();
  };

  handleValidation = () => {
    let hasValidationErrors = false;
    const { values } = this.props;
    const { error } = this.state;
    if (values.gradeLevel === "") {
      error.gradeLevel = true;
      this.setState({
        error,
      });
      hasValidationErrors = true;
    } else {
      error.gradeLevel = false;
      this.setState({
        error,
      });
    }

    if (values.paymentSchedule === "") {
      error.paymentSchedule = true;
      this.setState({
        error,
      });
      hasValidationErrors = true;
    } else {
      error.paymentSchedule = false;
      this.setState({
        error,
      });
    }

    if (hasValidationErrors) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    const { values, handleChange } = this.props;
    let breakdownLevel, scheduleOfPayment, ue, amt;
    if (values.gradeLevel) {
      breakdownLevel = _.find(breakdownOfFees, {
        gradeLevel: values.gradeLevel,
      });
    }

    if (values.paymentSchedule) {
      scheduleOfPayment = _.find(tuitionFeeSched, {
        gradeLevel: values.gradeLevel,
      });

      if (values.paymentSchedule === "Full Cash Basis") {
        ue = scheduleOfPayment.cash;
        amt = "";
      } else if (values.paymentSchedule === "Semi-Annual") {
        ue = scheduleOfPayment.uponEnrollmentSemi;
        amt = scheduleOfPayment.semi;
      } else if (values.paymentSchedule === "Quarterly") {
        ue = scheduleOfPayment.uponEnrollmentQuarterly;
        amt = scheduleOfPayment.quarterly;
      } else if (values.paymentSchedule === "Monthly Basis") {
        ue = scheduleOfPayment.uponEnrollmentMonthlyPlusBooks;
        amt = scheduleOfPayment.monthly;
      } else {
        ue = "";
        amt = "";
      }
    }

    return (
      <Segment className="enrollment-form-segment">
        <h1>Enrollment Details</h1>
        {this.state.haveErrors && (
          <Message error content={this.state.message} />
        )}
        <Form>
          <Form.Group>
            <Form.Field
              required
              error={this.state.error.gradeLevel}
              width={8}
              value={values.gradeLevel}
              name="gradeLevel"
              control={Select}
              label="Grade Level"
              options={optionsGradeLevel}
              placeholder="Grade Level"
              onChange={handleChange}
            />
            <Form.Field
              required
              error={this.state.error.paymentSchedule}
              width={8}
              value={values.paymentSchedule}
              name="paymentSchedule"
              control={Select}
              label="Payment Schedule"
              options={optionsPaymentSchedule}
              placeholder="Payment Schedule"
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
        {values.gradeLevel !== "" && (
          <div style={{ marginBottom: "14px" }}>
            <span>Breakdown of Fees</span>
            {/* Add warning message about books column */}
            <Message
              warning
              size="small"
              style={{ marginTop: "5px", marginBottom: "10px" }}
            >
              <Message.Header>Important Note</Message.Header>
              <p>
                The <strong>BOOKS</strong> column shows estimated costs and is
                not yet final. Actual book costs will be confirmed during
                assessment.
              </p>
            </Message>
            <Table unstackable celled size="small">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>LEVEL</Table.HeaderCell>
                  <Table.HeaderCell>TUITION FEES</Table.HeaderCell>
                  <Table.HeaderCell>MISC FEES</Table.HeaderCell>
                  <Table.HeaderCell>BOOKS</Table.HeaderCell>
                  <Table.HeaderCell>TOTAL</Table.HeaderCell>
                  <Table.HeaderCell>DEPED SUBSIDY</Table.HeaderCell>
                  <Table.HeaderCell>
                    GRAND TOTAL (TF, MISC, BOOKS)
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                <Table.Row>
                  <Table.Cell>{breakdownLevel.gradeLevel}</Table.Cell>
                  <Table.Cell textAlign="right">
                    {breakdownLevel.tuition}
                  </Table.Cell>
                  <Table.Cell textAlign="right">
                    {breakdownLevel.misc}
                  </Table.Cell>
                  {/* Highlight the books cell with a warning color */}
                  <Table.Cell textAlign="right" warning>
                    {breakdownLevel.books}
                  </Table.Cell>
                  <Table.Cell textAlign="right">
                    {breakdownLevel.total}
                  </Table.Cell>
                  <Table.Cell textAlign="right" color="green">
                    {breakdownLevel.subsidy}
                  </Table.Cell>
                  <Table.Cell textAlign="right">
                    <strong>{breakdownLevel.grandTotal}</strong>
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
        )}
        {(values.paymentSchedule && values.gradeLevel) !== "" && (
          <div style={{ marginBottom: "14px" }}>
            <span>Payment Schedule</span>
            <Table unstackable celled size="small">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>LEVEL</Table.HeaderCell>
                  <Table.HeaderCell>PAYMENT SCHEDULE</Table.HeaderCell>
                  <Table.HeaderCell>UPON ENROLLMENT</Table.HeaderCell>
                  <Table.HeaderCell>NEXT PAYMENT</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              <Table.Body>
                <Table.Row>
                  <Table.Cell>{scheduleOfPayment.gradeLevel}</Table.Cell>
                  <Table.Cell textAlign="right">
                    {values.paymentSchedule}
                  </Table.Cell>
                  <Table.Cell textAlign="right">{ue}</Table.Cell>
                  <Table.Cell textAlign="right">{amt}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <span>
              {" "}
              NOTE: Subsidies, vouchers, and other grants are not yet included
              in this computation. Your actual computation will be sent to you
              after the assessment.
            </span>
          </div>
        )}

        <Grid>
          <Grid.Column width={8}></Grid.Column>
          <Grid.Column width={8} textAlign="right">
            <Button onClick={this.back}>Back</Button>
            <Button onClick={this.continue}>Continue</Button>
          </Grid.Column>
        </Grid>
      </Segment>
    );
  }
}

export default EnrollmentDetails;
